/* eslint-disable @typescript-eslint/naming-convention */

export type MarketBarMessageData = {
    CLOSE: number;
    DATE_TIME: string;
    HIGH: number;
    LOW: number;
    NUMBER_OF_TICKS: number;
    OPEN: number;
    TIME: string;
    VALUE: number;
    VOLUME: number;
};

export type MarketBarStart = {
    MarketBarStart: MarketBarMessageData;
};
export type MarketBarUpdate = {
    MarketBarUpdate: MarketBarMessageData;
};
export type MarketBarEnd = {
    MarketBarEnd: MarketBarMessageData;
};
export type MarketBarIntervalEnd = {
    MarketBarIntervalEnd: MarketBarMessageData;
};

export function getMarketBarMessageData(
    message: unknown
): MarketBarMessageData | undefined {
    return (
        (message as MarketBarStart).MarketBarStart ||
        (message as MarketBarUpdate).MarketBarUpdate ||
        (message as MarketBarEnd).MarketBarEnd ||
        (message as MarketBarIntervalEnd).MarketBarIntervalEnd
    );
}
